// extracted by mini-css-extract-plugin
export default {"clickableMarket":"handraisersConversion_clickableMarket__AFIIi"};